import { CompatibilityContainer } from "./style";
import SignSelector from "./components/SignSelector";
import CompatibilityResult from "./components/CompatibilityResult";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import CompatibilityListBySign from "./components/CompatibilityListBySign";
import SignsCharacteristics from "./components/SignsCharacteristics";
import { WesternAstrology } from "../../../Astrology/components/WesternAstrology";

const Compatibility = (props) => {
  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};

  const { compatibilitySigns, zodiac } = rest?.properties?.service?.data;

  return (
    <CompatibilityContainer>
      <div className="compatibility-header">
        <h1 className="compatibility-header-title">
          Compatibilidades entre signos
        </h1>
        <p className="compatibility-header-text">
          La numerología es una práctica que utiliza los números y que pretende
          establecer una relación mística entre los números, los seres vivos y
          las fuerzas físicas o espirituales.
        </p>
      </div>
      <SignSelector />
      <div className="compatibility-content">
        {compatibilitySigns ? (
          <>
            <CompatibilityResult compatibilitySigns={compatibilitySigns} />
            <CompatibilityListBySign signs={compatibilitySigns} />
            <div className="compatibility-western-separator">
              <h2 className="compatibility-western-title">Horóscopo diario</h2>
            </div>
            <WesternAstrology zodiac={zodiac} />
          </>
        ) : (
          <SignsCharacteristics />
        )}
      </div>
    </CompatibilityContainer>
  );
};

export default Compatibility;
